import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthProvider';
import { AppSidebar } from './AppSidebar';
import { TopbarUser } from './UserMenu';

/**
 * Guscio del pannello di amministrazione: stessa sidebar della dashboard, con
 * "Impostazioni" come voce attiva. La top bar non ha selettore brand né tab dei
 * livelli, che qui non hanno senso.
 */
export function AdminShell({
  children,
  onBack,
}: {
  children: ReactNode;
  onBack: () => void;
}): ReactNode {
  const { t } = useTranslation();
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="app">
      <AppSidebar user={user} active="settings" />

      <div className="main">
        <header className="topbar">
          <button type="button" className="topbar-export" onClick={onBack}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M19 12H5M11 18l-6-6 6-6" />
            </svg>
            {t('admin.backToDashboard')}
          </button>

          {/* Stesso menu della dashboard: identità, lingua e disconnessione.
              Prima qui c'erano una `sector-badge` con l'email e un pulsante di
              logout testuale, senza selettore di lingua — nel pannello la
              lingua non si poteva cambiare affatto. */}
          <TopbarUser user={user} />
        </header>

        <div className="content">{children}</div>
      </div>
    </div>
  );
}
